import React from "react";
import { useDispatch } from "react-redux";

import { DeleteInventory } from "../../../Store/Thunk";
import { ConfirmDeleteButton } from "../../../../../SharedComponents/ListView";

export default function DeleteButton({ inventory }) {
  const dispatch = useDispatch();

  const GetSchemeImageNames = () => {
    let imageNames = [];
    if (inventory.reportScheme?.adminWrapUpJson) {
      var scheme = JSON.parse(inventory.reportScheme?.adminWrapUpJson);
      scheme.forEach((item) => {
        if (item.componentName === "ImageSpace") return imageNames.push(item.imageName);
      });
    }

    return JSON.stringify(imageNames);
  };

  return (
    <ConfirmDeleteButton
      onConfirm={() =>
        dispatch(DeleteInventory({ id: inventory.id, schemeImagesJson: GetSchemeImageNames() }))
      }
    />
  );
}
